import React, { useState } from 'react';
import { Typography } from '../common/Typography';
import TournamentMatchCard from './TournamentMatchCard';

const GroupMatchSection = ({
  groupId,
  groupName,
  title,
  matches,
  playedCount,
  totalCount,
  isSingles,
  canManage,
  onOpenScore,
  metaMode = 'group',
}) => {
  const [expanded, setExpanded] = useState(true);
  const panelId = `group-matches-${groupId}`;
  const total = totalCount ?? matches.length;
  const playedLabel = `${playedCount} of ${total} played`;
  const heading = title || `Group ${groupName}`;

  return (
    <div className="overflow-hidden rounded-xl border border-border-medium">
      <button
        type="button"
        aria-expanded={expanded}
        aria-controls={panelId}
        onClick={() => setExpanded((open) => !open)}
        className="flex min-h-[44px] w-full items-center justify-between gap-3 bg-surface-subtle px-3 py-2.5 text-left transition-colors hover:bg-surface-elevated"
      >
        <span className="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <Typography as="span" variant="strong" className="text-sm text-text-primary">
            {heading}
          </Typography>
          <Typography as="span" variant="caption" className="text-text-muted">
            {playedLabel}
          </Typography>
        </span>
        <svg
          className={`h-5 w-5 shrink-0 text-text-secondary transition-transform duration-200 ${
            expanded ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {expanded ? (
        <div id={panelId} className="space-y-3 border-t border-border-medium bg-surface px-3 py-3">
          {matches.map((match) => (
            <TournamentMatchCard
              key={match.id}
              match={match}
              isSingles={isSingles}
              canManage={canManage}
              onOpenScore={onOpenScore}
              metaMode={metaMode}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default GroupMatchSection;
